import { HttpClient } from "./core/HttpClient";

type HttpClientMap<C extends Record<string, any>, T = HttpClient<C>> = Record<
  keyof T,
  T
>;

export const forEachHttpClient = <
  C extends Record<string, any>,
  O extends object = HttpClientMap<C>
>(
  obj: O,
  fn: (value: O[keyof O], key: keyof O) => void
) => {
  const keys = Object.keys(obj) as (keyof O)[];
  keys.map((key) => {
    const value = obj[key];
    fn(value, key);
  });
};
